import { createSelector } from 'reselect';
import { SUPER_ADMIN } from '../../constants/Scopes';
import { getScopes } from './getScopes';
export const getUserIsSuperAdmin = createSelector(getScopes, scopes => scopes.includes(SUPER_ADMIN));